import React from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Box,
  Typography,
  Chip,
  Stack,
  Divider,
} from "@mui/material";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { QK } from "../../../base/qk";
import { getAllergiesByID } from "../../../api/services/allergy";

const Allergies = () => {
  const { id: clientID } = useParams();

  const { data: allergies, isLoading } = useQuery(
    [QK.allergies, clientID],
    () => getAllergiesByID(clientID),
    {
      enabled: !!clientID,
    }
  );

  if (isLoading) {
    return (
      <Card sx={{ borderRadius: "12px", boxShadow: "0px 4px 12px rgba(0,0,0,0.05)" }}>
        <CardContent>
          <Typography color="text.secondary">Loading allergies...</Typography>
        </CardContent>
      </Card>
    );
  }

  const allergyList = allergies || [];

  return (
    <Card
      sx={{
        borderRadius: "12px",
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.05)",
        overflow: "hidden",
        height: "100%",
      }}
    >
      <CardHeader
        sx={{
          px: 2.5,
          py: 2,
          bgcolor: "#FAFBFC",
          borderBottom: "1px solid #F2F4F7",
        }}
        title={
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Box
              sx={{
                width: 32,
                height: 32,
                borderRadius: "8px",
                bgcolor: "#FEF3C7",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <MedicalServicesIcon sx={{ color: "#F59E0B", fontSize: 18 }} />
            </Box>
            <Typography variant="subtitle1" fontWeight={600} sx={{ color: "#1A1A2E" }}>
              Allergies
            </Typography>
            <Chip
              label={allergyList.length}
              size="small"
              sx={{
                bgcolor: "#F2F4F7",
                color: "#667085",
                fontWeight: 500,
                fontSize: "0.7rem",
                height: 20,
              }}
            />
          </Box>
        }
      />

      <CardContent sx={{ p: 2.5 }}>
        {allergyList.length === 0 ? (
          <Box sx={{ textAlign: "center", py: 2 }}>
            <Typography variant="body2" color="text.secondary">
              No allergies recorded
            </Typography>
          </Box>
        ) : (
          <Stack spacing={1.5}>
            {allergyList.map((allergy, index) => (
              <Box key={allergy.id || index}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                  <WarningAmberIcon sx={{ color: "#EF4444", fontSize: 16 }} />
                  <Box>
                    <Typography variant="body2" fontWeight={500} sx={{ color: "#1A1A2E" }}>
                      {allergy.name || allergy.allergy_type?.name || "Unknown Allergy"}
                    </Typography>
                    {allergy.comment && (
                      <Typography variant="caption" color="text.secondary" sx={{ display: "block" }}>
                        {allergy.comment}
                      </Typography>
                    )}
                  </Box>
                </Box>
                {index < allergyList.length - 1 && <Divider sx={{ mt: 1.5 }} />}
              </Box>
            ))}
          </Stack>
        )}
      </CardContent>
    </Card>
  );
};

export default Allergies;